// Shared Tailwind color classes for the small icon-chip badges the assistant
// chat uses to visually categorize a tool/action. Both the Capabilities
// popover's prefix-based categories (ToolsPopover.vue) and the empty-state
// suggested-prompt chips (Conversation.vue) key into this by the same names,
// so the same underlying tool reads as the same color in both places — kept
// here once instead of duplicated in each file.
export const AGENT_ACCENT_CLASSES = {
  sky: 'bg-sky-100 text-sky-600 dark:bg-sky-500/10 dark:text-sky-400',
  iris: 'bg-iris-100 text-iris-600 dark:bg-iris-500/10 dark:text-iris-400',
  mantis: 'bg-mantis-100 text-mantis-800 dark:bg-mantis-500/10 dark:text-mantis-400',
  peach: 'bg-peach-100 text-peach-700 dark:bg-peach-500/10 dark:text-peach-400',
  amber: 'bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400',
  charcoal: 'bg-charcoal-100 text-charcoal-600 dark:bg-charcoal-800 dark:text-charcoal-300',
}
